import React, {useContext, useState} from "react";

import EditView from "../../component/EditView";
import Texto from "../../component/form/texto/Texto";

import Diferencial from "../../model/Diferencial";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import FormUtils from "../../utils/FormUtils";
import {TooltipPosition} from "../../component/form/TooltipPosition";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";

function DiferencialEdit() {
    const { error } = useContext(MensagemContext) as MensagemContextType;
    const [entidade, setEntidade] = useState<Diferencial>({});

    const editEntidade = (data: Diferencial) => {
        setEntidade(data);
    }

    const entidadeOnChangeHandler = (e: any) => {
        setEntidade({ ...entidade, [e.target.id]: e.target.value });
    }

    const validar = async (): Promise<boolean> => {
        if (!entidade.nomeDiferencial) {
            FormUtils.invalidarComponente(error, "Descrição é obrigatório.");
            return false;
        }

        return true;
    }

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <EditView title={ "Diferencial" }
                          id={`${process.env.REACT_APP_REST_DIFERENCIAL}`}
                          entidade={ entidade }
                          onValidationHandler={ validar }
                          entidadeUseStateFunction={ editEntidade }>

                    <Texto id={ "nomeDiferencial" } value={ entidade.nomeDiferencial }
                           label={ "* Descrição" } size={ "100%" } maxLength={ 20 }
                           tooltip={"Informe a descrição"} tooltipPosition={TooltipPosition.TOP}
                           onChangeHandler={entidadeOnChangeHandler} />

                </EditView>
            </RoleBasedAccess>
        </>
    );
}

export default DiferencialEdit;